import { render } from "./CarePlanView.vue?vue&type=template&id=99c0429a"
import script from "./CarePlanView.vue?vue&type=script&lang=js"
export * from "./CarePlanView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__